import { atom } from "recoil";

export const dataSearchList = atom({ key: "dataSearchListPBA", default: {} });
